import React from 'react'
import { CiUser } from "react-icons/ci";
import { GoQuestion } from "react-icons/go";
import LogoutButton from './LogoutButton';
import PropTypes from 'prop-types';

const Profile = ({ isOpen }) => {
  return (
    <div className={`absolute right-5 w-3/4 bg-white shadow-lg rounded-lg ${isOpen ? 'block' : 'hidden'}`}  style={{ bottom: '60px' }}>
      <div className='grid gap-4 px-2 py-3'>
        <div className='flex flex-col'>
          <a className="block w-full hover:bg-gray-200 text-gray-500 font-medium py-2 pl-2 rounded text-left mb-1" href="https://medium.com/@usedeli/help-with-navigating-deli-a0dbaf99aba3">
            <div className="flex items-center">
              <CiUser size={24}/> <span className="ml-2">Help</span>
            </div>
          </a>
          <a className="block w-full hover:bg-gray-200 text-gray-500 font-medium py-2 pl-2 rounded text-left" href={`https://billing.stripe.com/p/login/${import.meta.env.VITE_REACT_APP_STRIPE_MANAGE}`}>
            <div className="flex items-center">
              <GoQuestion size={20}/> <span className="ml-2">Manage Billing</span>
            </div>
          </a>
          <div className='border-b-2 border-gray-200 mb-1 mt-1'></div>
          <LogoutButton />
        </div>
      </div>
  </div>
  )
}

Profile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default Profile